<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Checklist Rating</h4>
    <hr >
    <div
      v-if="isFetching"
      style="margin: 0 auto; width: 10px;">
      <div class="loader-dark-blue medium mb-5 mt-5"/>
    </div>
    <b-row v-if="!isFetching">
      <b-col>
        <div
          v-for="(zone, index) in zones"
          :key="zone.CODE"
          class="mt-3">
          <b-btn
            :class="[zone.COLLAPSED ? null : 'collapsed']"
            :aria-controls="zone.CODE"
            :aria-expanded="zone.COLLAPSED ? 'true' : 'false'"
            class="text-left"
            block
            variant="secondary"
            size="lg"
            @click="toggleCollapse(index)">
            <span>
              <i :class="[zone.COLLAPSED ? 'icon-minus' : 'icon-plus']"/> {{ zone.NAME }}
            </span>
          </b-btn>
          <b-collapse
            :id="zone.CODE"
            v-model="zone.COLLAPSED">
            <StationsView
              :stations="stationsByZone(zone.CODE)"
              :car-in-stations="carInStations"
              :car-logs="logs" />
              <!-- <StationsView v-if="zone.STATION_COLLAPSED" :stations="stationsByZone(zone.CODE)" :car-in-stations="carInStations" :car-logs="logs" /> -->
          </b-collapse>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import StationsView from './StationsView'
import { mapState } from 'vuex'

export default {
  name: 'CleaningLogs',
  components: {
    StationsView
  },
  computed: {
    ...mapState('cleaningLogs', {
      isFetching: state => state.isFetching,
      logs: state => state.cleaningLogs,
      zones: state => state.zones,
      stations: state => state.stations,
      carInStations: state => state.carInStations
    })
  },
  created () {
    this.loadLogs()
  },
  methods: {
    stationsByZone (zoneCode) {
      return this.$store.getters['cleaningLogs/getStationsByZone'](zoneCode)
    },
    toggleCollapse (idx) {
      this.$store.commit('cleaningLogs/toggleZone', {idx: idx})
    },
    loadLogs() {
      this.$store.commit('cleaningLogs/setIsFetching', true)
      Promise.all([
        this.$store.dispatch('cleaningLogs/fetchZones'),
        this.$store.dispatch('cleaningLogs/fetchStations'),
        this.$store.dispatch('cleaningLogs/fetchCars'),
        this.$store.dispatch('cleaningLogs/fetchCarInStations'),
        this.$store.dispatch('cleaningLogs/fetchCleaners'),
        this.$store.dispatch('cleaningLogs/fetchCleaningLogs')
      ]).then(() => {
        this.$store.dispatch('cleaningLogs/composeLogsData')
        this.$store.commit('cleaningLogs/setIsFetching', false)
      })
    }
  }
}
</script>
